<h1
    [attr.id]="headlineId() ?? null"
    class="c:blue-700"
>
    {{ headline() }}
</h1>
<app-kebab-menu
    class="menu"
    [menuItems]="menuItems"
/>
